<h2 matDialogTitle class="mat-h2">Conversion Rate</h2>

<mat-dialog-content>
  <mat-divider></mat-divider>
  <p class="mat-body-2" style="margin-bottom: 24px;">This ad campaign's Conversion Rate for the past 30 days is:</p>
  <div class="conversion-text">
    <ng-container *ngIf="merchantAd.calculated_conversion_rate">{{merchantAd.calculated_conversion_rate / 100 | percent:'1.2-2'}}</ng-container>
    <ng-container *ngIf="merchantAd.calculated_conversion_rate === null">n/a</ng-container>
    <ng-container *ngIf="merchantAd.calculated_conversion_rate === 0">0%</ng-container>
  </div>
  <div class="button-group">
    <button mat-raised-button mat-dialog-close color="primary">Close</button>
  </div>
</mat-dialog-content>
